import type { DeviationFE } from 'domain/vehicle';
import { pipe, sortBy } from 'remeda';

import { setSeverity } from './setSeverity';

/** Sort key for a deviation's `sentAt`; a missing timestamp sorts first (epoch 0), as before. */
const sentAtKey = (deviation: DeviationFE): number => deviation.sentAt?.getTime() ?? 0;

export const getOldestDeviation = (deviations: DeviationFE[]) => {
    const severity = setSeverity(deviations);

    const sortedDeviations = pipe(Object.values(deviations), (_: DeviationFE[]) =>
        sortBy(
            _.filter(deviation => deviation.severity === severity),
            [sentAtKey, 'desc']
        )
    );

    return sortedDeviations[0]?.sentAt?.toISOString() ?? String(new Date());
};
